import axios from "axios";
const back_url = process.env.REACT_APP_BACKEND_URL;
const apiClient = axios.create({
  baseURL: back_url,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;

//Function to register a new user
export const addPatientAction = async (payload: any) => {
  try {
    const response = await apiClient.post("/patient/add", payload);
    if (response.data && response.data.status === "success") {
      return response; // This now correctly returns the user object
    } else {
      console.error("Adding patient failed with status:", response);
      return response;
    }
  } catch (err) {
    console.error("Error during patient submit:", err);
    throw err; // Optionally re-throw to handle the error in the component
  }
};

export const getPatientListAction = async () => {
  try {
    const response = await apiClient.get("/patient/get_all");
    if (response.data && response.data.status === "success") {
      return response.data; // This now correctly returns the user object
    } else {
      console.error("Fetching patient list failed with status:", response);
      return response;
    }
  } catch (error) {
    console.error("Error fetching patient list:", error);
  }
};

export const getPatientsByAdmin = async () => {
  try {
    const response = await apiClient.get("/patient/admin/get_all_patient");
    if (response.data && response.data.status === "success") {
      return response.data; // This now correctly returns the user object
    } else {
      console.error("Fetching patient list failed with status:", response);
      return response;
    }
  } catch (error) {
    console.error("Error fetching patient list:", error);
  }
};

export const getSinglePatientAction = async (patientId: string | undefined) => {
  try {
    const response = await apiClient.get(`/patient/single/${patientId}`);
    if (response.data && response.data.status === "success") {
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching patient information:", error);
    return [];
  }
};

export const downloadPatientDocument = async (documentId: string) => {
  try {
    const response = await apiClient.get(
      `/patient/download_document/${documentId}`
    );
    if (response.data && response.data.status === "success") {
      return response.data;
    } else {
      console.error("Get Case List failed with status:", response);
      return response;
    }
  } catch (error) {
    console.error("Error fetching case list:", error);
  }
};

export const deletePatient = async (patientId: string) => {
  try {
    const response = await apiClient.post(
      `/patient/delete_patient/${patientId}`
    );
    if (response.data && response.data.status === "success") {
      return response.data;
    } else {
      console.error("Get Case List failed with status:", response);
      return response;
    }
  } catch (error) {
    console.error("Error fetching case list:", error);
  }
};

export const getIndividualPatientDoc = async (payload: any) => {
  try {
    const response = await apiClient.get(`/patient/get/${payload}`, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    return;
  }
};

export const getTotal = async () => {
  try {
    const response = await apiClient.get("/patient/admin/get_all");
    if (response.data && response.data.status === "success") {
      return response.data; // This now correctly returns the user object
    } else {
      console.error("Fetching patient list failed with status:", response);
      return response;
    }
  } catch (error) {
    console.error("Error fetching patient list:", error);
  }
};
